function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#B6BCD1",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "M72.612 3.211l-5.945 7.752 3.034 6.057s.97 3.634.485 4.118c-.485.606-3.397 7.268-3.397 7.268l3.518 5.572 1.577 3.876-5.095 6.54-3.519.97 5.096 7.994-.243 4.603-2.548 4.119s-1.213 3.512-1.698 4.118c-.364.606 3.518 6.783 3.518 6.783l2.184 5.209-4.489 4.118s-.364 2.544-1.213 3.15c-.85.484-1.82 7.146-1.82 7.146s1.941 2.907 2.305 3.997c.243 1.09-1.456 3.27-1.456 3.27l47.56 6.057 12.376-96.176-50.23-6.54zM2.607 3.696l46.468-1.333-4.61 8.6 4.003 5.572 1.092 3.998-2.184 7.752 4.368 4.966 2.063 3.513-4.125 7.267-3.276 1.454 6.309 7.147.485 4.602-1.941 4.482-.97 4.24 4.488 6.177 3.033 4.724-3.882 4.724-.728 3.27-.728 7.268 2.79 3.634-.849 3.392-49.137 1.332z"
}));

function SvgBorderlessDamageInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 109,
    viewBox: "0 0 126 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderlessDamageInactive);
export default __webpack_public_path__ + "static/media/borderless-damage-inactive.26f8547d.svg";
export { ForwardRef as ReactComponent };